import React, { useEffect, useState } from "react";
import Gauge from "../Components/Gauge";
import { AgCharts } from "ag-charts-react";
import FilterSelector from "../Components/FilterSelector";

function ExpensePredictability({ data }) {
  const [activeDuration, setActiveDuration] = useState("overall_summary");
  const [barGraph, setBarGraph] = useState([]);
  const [series, setSeries] = useState([]);
  const [scoreData, setScoreData] = useState({
    score: 0,
    status: "",
  });
  function formatToIndianRupees(num) {
    // Convert the number to a string
    if (num === null || num === undefined) return "₹--";
    return num.toLocaleString("en-IN", {
      maximumFractionDigits: 0,
      style: "currency",
      currency: "INR",
    });
  }
  const getColor = (remark) => {
    switch (remark) {
      case "Critical":
      case "Low":
        return "#d30d00";
      case "Medium":
        return "#f7a452";
      case "High":
        return "#00960f";
      default:
        return "#f7a452";
    }
  };
  const [options, setOptions] = useState({
    data: barGraph,
    series: series,
    legend: {
      item: {
        label: {
          fontSize: 11, // Change the legend font size

          fontWeight: "normal",
          color: "#637381", // Change the legend font color
        },
        marker: {
          size: 11, // Change the size of the color boxes
        },
      },
    },

    axes: [
      {
        type: "category",
        position: "bottom",
        gridLine: false,
        label: {
          fontSize: 9,
          fontWeight: "light",
        },
      },
      {
        type: "number",
        position: "left",
        label: {
          fontWeight: "normal",
          fontSize: 11,
          formatter: (params) => {
            // Format with thousand separators and add a currency symbol
            return `${formatToIndianRupees(params.value)}`;
          },
        },
        gridLine: false,
      },
    ],
    barPadding: 0.1, // Default is 0.1, lower this value to reduce bar width
    groupPadding: 0.1,
    height: 340,
  });

  const mapDataBarGraph = (data, lineArray) => {
    const array = Object.keys(data).map((key, index) => {
      const quarter = key;
      const main = data[key];
      const subObject = Object.keys(main).reduce((acc, subkey) => {
        acc[subkey] = main[subkey]; // Set the value to the second element
        return acc;
      }, {});
      return {
        quarter: quarter,
        ...subObject,
        income: lineArray[index],
      };
    });

    return array;
  };

  const mapSeries = (data) => {
    const array = data.map((item, index) => {
      return {
        type: "bar",
        xKey: "quarter",
        yKey: item,
        yName: item,
        cornerRadius: 10,
        // fill: baseColors[index % baseColors.length],
        stacked: true,
      };
    });
    array.push({
      type: "line",
      xKey: "quarter",
      yKey: "income",
      yName: "Income (Monthly)",
      stroke: "#0070d2",
      strokeWidth: 2,
      lineDash: [6, 3],
      marker: { enabled: false },
    });

    return array;
  };
  useEffect(() => {
    setBarGraph(
      mapDataBarGraph(
        data
          ? data[activeDuration]?.expense_predictability_score
              .expense_categories
          : {},
        data
          ? data[activeDuration]?.expense_predictability_score.income_data[
              "y-axis"
            ]
          : []
      )
    );
    setSeries(
      mapSeries(
        data
          ? data[activeDuration]?.expense_predictability_score?.legend_array
          : []
      )
    );
    if (data) {
      setScoreData({
        score:
          data[activeDuration]?.expense_predictability_score
            ?.newbank_expense_predictability_score,
        status:
          data[activeDuration]?.expense_predictability_score
            ?.expense_predictability_status,
      });
    }
  }, [activeDuration, data]);
  useEffect(() => {
    setOptions({ ...options, data: barGraph, series: series });
  }, [barGraph, series]);

  return (
    <div className="  border border-[#e6ebed] rounded-lg pb-2 w-[49.5%]">
      <div className=" rounded-t-lg bg-[#f3f3f3] py-3 px-4 text-[#212b36] font-bold">
        <p>Expense Predictability Score</p>
      </div>
      <FilterSelector
        setActiveDuration={setActiveDuration}
        activeDuration={activeDuration}
      />
      <div className=" mt-1 ">
        <Gauge value={scoreData?.score?.toFixed(1)} status={scoreData.status} />
      </div>
      <div className="  mt-[56px]">
        <p className="text-[#212b36] text-xs font-bold ml-[15.75px]">
          Expense Categorization
        </p>
        <div className="mt-1 ">
          <AgCharts options={options} />{" "}
        </div>
      </div>
    </div>
  );
}

export default ExpensePredictability;
